(function () {
  function initGalleryStickyGrid(root) {
    if (root.dataset.galleryStickyGridInited === 'true') return;
    root.dataset.galleryStickyGridInited = 'true';

    const dialog = root.querySelector('dialog[data-gallery-sticky-lightbox]');
    const img = dialog?.querySelector('[data-gallery-sticky-lightbox-img]');
    const closeBtn = dialog?.querySelector('[data-gallery-sticky-lightbox-close]');
    if (!dialog || !img) return;

    root.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-gallery-lightbox-trigger]');
      if (!trigger || !root.contains(trigger)) return;
      event.preventDefault();
      const src = trigger.getAttribute('data-lightbox-src');
      const alt = trigger.getAttribute('data-lightbox-alt') || '';
      if (!src) return;
      img.src = src;
      img.alt = alt;
      img.removeAttribute('width');
      img.removeAttribute('height');
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      }
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) {
        dialog.close();
      }
    });

    closeBtn?.addEventListener('click', () => {
      dialog.close();
    });
  }

  function initAll(scope) {
    const roots = scope.querySelectorAll('[data-gallery-sticky-grid]');
    for (const root of roots) {
      initGalleryStickyGrid(root);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
